import { ToastType } from "@/components/ui/use-toast";
import { DefaultErrorResponse } from "../entities";

export function getToastErrorContent(err: any): ToastType {
  const error = err as DefaultErrorResponse

  return { variant: "destructive", description: error?.response?.data?.message ?? 'Ocorreu um erro inesperado', }
}